import { type FC, useCallback } from 'react'
import { useThemedNativeBackdrop } from '@dhl/native-modal'
import { ConfirmationModal, type ConfirmationModalProps } from '@dhl/receiver-design'

export const ConfirmationDialog: FC<ConfirmationModalProps> = (props) => {
  const { hideNativeBackdrop, showNativeBackdrop } = useThemedNativeBackdrop()

  const handleOpen = useCallback(showNativeBackdrop, [showNativeBackdrop])
  const handleClose = useCallback(hideNativeBackdrop, [hideNativeBackdrop])

  return <ConfirmationModal {...props} onClose={handleClose} onOpen={handleOpen} />
}
